import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";


/**
 * GenerateCadastroPesquisaListaColumnDefinition
 */

type Props = {
  onActionEditar: (idPesquisaSatisfacao: number | null, openState: boolean) => void;
  onActionDelete: (idPesquisaSatisfacao: number | null, openState: boolean) => void;
  onActionGoToItens: (idPesquisaSatisfacao: number, openNewTab: boolean) => void;
};

export const GenerateCadastroPesquisaListaColumnDefinition = ({
  onActionEditar,
  onActionDelete,
  onActionGoToItens,
}: Props): GridColDef[] => {

  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Ativo";
      case 0:
        return "Inativo";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Ativo";
      case 0:
        return "Inativo";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "",
      minWidth: 110,
      width: 110,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemStatusTitle(value)}
            color={computeItemStatusColor(value)}
            description={computeItemStatusDescription(value)}
          />
        </div>
      )
    },
    {
      field: "codigo",
      filterable: false,
      headerName: "Código",
      width: 130,
      minWidth: 130,
      sortable: false,
      align: 'left',
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 200,
      sortable: false,
      align: 'left',
    },
    {
      field: 'idPesquisaSatisfacao',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                onActionEditar(value, true);
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDelete(value, true); }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
    {
      field: "itens",
      filterable: false,
      headerName: "Itens",
      width: 110,
      sortable: false,
      resizable: false,
      valueGetter: (_, rows) => ({
        idPesquisaSatisfacao: rows['idPesquisaSatisfacao'],
      }),
      renderCell: ({ value: { idPesquisaSatisfacao } }) => {
        return (
          <Button
            onMouseDown={e => {
              if (e.button === 1) {
                onActionGoToItens(idPesquisaSatisfacao, true);
              } else {
                onActionGoToItens(idPesquisaSatisfacao, e.ctrlKey);
              }
              e.preventDefault();
            }}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.3rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
              width: '5rem',
            }}>
            Itens
          </Button>
        );
      },
    },
  ];
}